<div class="w-100 h-100">
  <im-loader></im-loader>
</div>
